<template>
    <div class="row">
        <div class="col-md-6">
            <table class="table enquiry-detail">
                <tbody>
                    <tr v-for="(config, field) in fields">
                        <td>{{ config.label }}</td>
                        <td v-html="config.value(_.get(messageData, field), __)"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-6">
            <table-component
                v-if="initialized"
                :content="statuses"
                :timestamp="timestamp"
                :selected="selected"
                :config="statusesConfig"
                :query="query"

                :getData="getData"
                :createData="modifiedCreateData"
                :updateBatch="modifiedUpdateBatch"
                :addNotification="addNotification"
                :changeQuery="doNothing"
                :changeUrl="doNothing"
                :onInitialized="doNothing"
                :onSelected="doNothing"
                ></table-component>
        </div>
    </div>
</template>
<script>
import Vuex from 'vuex';
import TableComponent from '72cms-ui/components/TableComponent';

export default {
    data() {
        return {
            initialized: false,
            fields: {
                type: {
                    label: 'Type',
                    value: (val) => { return val },
                },
                created_at: {
                    label: 'Created at',
                    value: (val, __) => { return __(val, ['datetime']) }
                },
                subject: {
                    label: 'Subject',
                    value: (val) => { return val },
                },
                email: {
                    label: 'Email',
                    value: (val) => { return `<a href="mailto:${val}">${val}</a>` },
                },
                plain_content: {
                    label: 'Content',
                    value: (val) => { return _.replace(val, /(?:\r\n|\r|\n)/g, '<br>') },
                },
            }
        }
    },

    props: ['content'],

    mounted() {
        this.$emit('content::initialized', {
            type: this.content.type,
            name: 'message-detail-component',
            config: {},
        });

        this.getInitialData(_.get(this.content, 'links.status'))
            .then(() => {
                this.initialized = true;
                this.$forceUpdate();
            })
    },

    components: {
        TableComponent,
    },

    computed: {
        ...Vuex.mapGetters('sub', {
            timestamp: 'timestamp',
            parent: 'parent',
            selected: 'selected',
            query: 'query',
        }),

        statuses() {
            return _.get(this.content, 'included.status');
        },

        statusesConfig() {
            return this.config(['collection', 'message.message_statuses'], {});
        },

        messageData() {
            return _.merge(this.content.attributes, this.content.meta);
        },
    },

    methods: {
        ...Vuex.mapActions({
            addNotification: 'addNotification',
        }, { root: true }),

        ...Vuex.mapActions('sub', {
            getInitialData: 'getInitialData',
            getData: 'getData',
            createData: 'createData',
            updateBatch: 'updateBatch',
        }),

        // modify top level API methods so that
        // they accept multiple arguments instead of just 1
        modifiedCreateData(data, options) {
            return this.createData({ data, options });
        },

        modifiedUpdateData(data, options) {
            return this.updateData({ data, options });
        },

        modifiedUpdateBatch(data, options) {
            return this.updateBatch({ data, options });
        },

        doNothing() {
            //
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/cms/js/components/MessageDetailComponent.vue